import { useNavigate, useRouteError } from "react-router-dom";
import { ROUTES } from "../../routes";
import NotFoundImg from "../../static/icons/NotFound.jpg";

export const PageNotFoundElement = () => {
  const error = useRouteError();
  const navigate = useNavigate();
  return (
    <>
      <div className="h-100 d-flex justify-content-center align-items-center">
        <div className="error-page text-center">
          <img
            src={NotFoundImg}
            alt="page not found"
            className="img-fluid"
            style={{ width: "350px" }}
          />
          <h2 className="text-capitalize">
            <span className="fw-bold">{error?.status} </span>
            <span>{error.statusText}</span>
          </h2>
          <div>
            <a
              className="btn btn-link"
              onClick={() =>
                navigate(ROUTES.LOGIN, {
                  replace: true,
                })
              }
            >
              Go Home
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
